<template lang="pug">
  .boleta
    .datos
      .icon
        i.fa.fa-file-pdf-o
      .data
        .up
          .big
            .left {{ boleta.nombreMes }} {{ boleta.periodo }}
            .right {{ boleta.descripcionTipo }}
          .small
            span Generado: {{ boleta.fechaGenerado }}
        .down
          .button(
            :class="{ 'is-primary': !boleta.visto }"
            @click="ver"
          )
            .button-fecha(v-if="boleta.visto")
              p Ver
              div.fecha Visto en {{ boleta.fechaVisto }}
            div(v-else)
              span Ver
          p.small.has-text-centered(v-if="!boleta.visto") Al ver su boleta, acepta la recepción de la misma
</template>

<script>
import { apiPost, notify } from '../util/general'
export default {
  name: 'boleta-item-lista',
  props: ['boleta'],
  data () {
    return {
      marcandoComoVisto : false
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
    ver () {
      var vm = this
      if (vm.boleta.visto) {
        vm.$emit('ver', vm.boleta)
        return
      }

      vm.marcandoComoVisto = true

      var obj = {
        periodo : vm.boleta.periodo,
        mes     : vm.boleta.mes,
        tipo    : vm.boleta.tipo,
        codigo  : vm.boleta.codigo
      }

      apiPost(vm, '/boleta/empleado/visto', obj, function (data) {
        vm.$emit('ver', vm.boleta)
        vm.$emit('refresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.marcandoComoVisto = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .datos
    display flex
    align-items center
  .icon
    width 100px
    color #565cde
    padding: 40px;
    i
      font-size 80px
  .data
    min-width 300px
    display flex
    align-items: center;
  .big
    display flex
    width: 300px;
    align-items: center
    .left
      font-size 20px
      color #a2a2a2
    .right
      padding-left 10px
      font-size 20px
      color #565cde
  .small
    text-align left
    font-size 12px
    color #cacaca
    margin-top: 0px;

  .down
    display flex
    flex-direction column
    // justify-content space-around
    margin-left 10px
    .button
      width 150px
      height 40px
      margin-left 5px
    p
      width 150px



  .disabled
    cursor pointer

  .button-fecha
    display flex
    flex-direction column
    .fecha
      font-size 10px


  .transition
    transition 0.3s all ease

  @media (max-width 670px)
    .data
      flex-direction: column
      .down
        margin-top 20px
      .up
        .big
          justify-content: center
        .small
          text-align: center

  @media (max-width 480px)
    .icon
      display:none
    .big
      flex-direction: column
</style>



// WEBPACK FOOTER //
// Component_Boletas_Item_Lista.vue?7e5ea352